import React from "react";
import WelcomeLogo from "@assets/images/WelcomeLOgo.svg";
import ReactModal from "react-modal";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { setWelcomePopup } from "@redux/slices/welcomePopupSlices";


const WelcomePopup = () => {
  const { t } = useTranslation();
  const isWelcomeOpen = useSelector(
    (state) => state.welcomePopup.isWelcomePopupOpen
  );

  const dispatch = useDispatch();


  return (
    <ReactModal
      isOpen={isWelcomeOpen}
      // onRequestClose={() => setShowModal(false)}
      className="relative w-[95vw] max-w-[531px] min-h-[400px] max-h-[90vh] font-[Lato] outline-none overflow-hidden rounded-[16px]"
      overlayClassName="fixed inset-0 flex items-center justify-center backdrop-blur-sm bg-black/50 z-50 p-4"
      style={{
        content: {
          // Responsive height that works with zoom
          height: "auto",
          minHeight: "400px",
          maxHeight: "90vh",
          // Center the modal
          margin: "auto",
          // Add scroll for content overflow
          overflowY: "auto",
        },
      }}
    >
      <div
        className="min-h-[400px] h-auto p-6 md:p-10 bg-cover flex flex-col justify-center bg-white rounded-xl"
      >
        {/* Content wrapper with responsive padding */}
        <div className="flex flex-col items-center text-center h-full">
          <div className="w-full max-w-[300px] mx-auto">
            <img
              src={WelcomeLogo}
              alt="Welcome Logo"
              className="w-full h-auto max-h-[200px] object-contain"
            />
          </div>

          <div className="mt-4 md:mt-6 w-full">
            <h1 className="text-[18px] md:text-[20px] font-[600] text-black font-[Lato]">
              {t("Everything Looks Great! 🎉")}
            </h1>
            <p className="text-[14px] md:text-[16px] font-[Lato] font-[400] mt-2 text-[#7B7B7B] text-center">
              {t("Your details are saved and we’re preparing your personalized plan. Feel free to explore your dashboard while we get things ready.")}
            </p>
          </div>

          {/* Buttons container with responsive layout */}
          <div className="mt-6 md:mt-8 w-full flex justify-center items-center gap-3">
            <button
              onClick={() => dispatch(setWelcomePopup(false))}
              className="w-full sm:w-auto min-w-[140px] text-[#fff] bg-[#4CDBFF] py-3 px-6 rounded-full hover:opacity-90 transition-opacity font-medium"
            >
              {t("Start Exploring")}
            </button>
           
          </div>
        </div>
      </div>
    </ReactModal>
  );
};

export default WelcomePopup;
